export default __webpack_public_path__ + "static/media/withdrawmodalinfo.9a031d44.svg";